document.addEventListener('DOMContentLoaded', () => {
    class FormSelector extends HTMLElement {
      constructor() {
        super();
        this.productFormBlock = this.closest('.flexi-product-form-block');
        this.productId = this.productFormBlock.dataset.productId;
        this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.variantInput = this.closest('.flexi-product-form-block').querySelector('input[name="id"]');
        this.priceDisplay = this.closest('.flexi-product-form-block').querySelector('.flexi-atc-price');
        this.compareAtPriceDisplay = this.closest('.flexi-product-form-block').querySelector('.flexi-atc-compare-at-price');
        this.priceBlockDisplay = document.querySelector(`[flexi-data-price-id="flexi-product-${this.productId}"]`);
        this.compareAtPriceBlockDisplay = document.querySelector(`[flexi-data-price-id="flexi-product-${this.productId}-compare"]`);
        this.addToCartButton = this.closest('.flexi-product-form-block').querySelector('[type="submit"]');
        this.currencyCode = document.documentElement.getAttribute('data-currency') || 'USD';
        this.addEventListener('change', this.onVariantChange.bind(this));
      }
  
      onVariantChange() {
        this.getSelectedOptions();
        this.getSelectedVariant();
        this.updatePrice();
        this.updateBlockPrice();
        this.updateVariantID();
  
        this.dispatchEvent(
          new CustomEvent('on:variant:change', {
            bubbles: true,
            detail: { variant: this.currentVariant },
          })
        );
      }
  
      getSelectedOptions() {
        this.variantoptions = this.fieldsets.map((fieldset) => {
          const selected = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
          return selected ? selected.value : null;
        });
      }
  
      getVariantJSON() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }
  
      getSelectedVariant() {
        const variants = this.getVariantJSON();
        this.currentVariant = variants.find((variant) => {
          return variant.options.every((option, index) => option === this.variantoptions[index]);
        });
      }
  
      updatePrice() {
        if (this.currentVariant && this.priceDisplay) {
          const priceInCents = this.currentVariant.price;
          const compareAtPriceInCents = this.currentVariant.compare_at_price;
      
          const formattedPrice = this.formatPrice(priceInCents, this.currencyCode);
          const formattedCompareAtPrice = this.formatPrice(compareAtPriceInCents, this.currencyCode);
      
          // Update the regular price
          this.priceDisplay.textContent = formattedPrice;
      
          // Update the comparison price
          if (compareAtPriceInCents > priceInCents && this.compareAtPriceDisplay) {
            this.compareAtPriceDisplay.textContent = formattedCompareAtPrice;
            this.compareAtPriceDisplay.style.display = 'inline';
          } else if (this.compareAtPriceDisplay) {
            this.compareAtPriceDisplay.style.display = 'none';
          }
        }
      }

      updateBlockPrice() {
        if (this.currentVariant && this.priceBlockDisplay) {
            const priceInCents = this.currentVariant.price;
            const compareAtPriceInCents = this.currentVariant.compare_at_price;
        
            const formattedPrice = this.formatPrice(priceInCents, this.currencyCode);
            const formattedCompareAtPrice = this.formatPrice(compareAtPriceInCents, this.currencyCode);
        
            // Update the regular price
            this.priceBlockDisplay.textContent = formattedPrice;
        
            // Update the comparison price
            if (compareAtPriceInCents > priceInCents && this.compareAtPriceBlockDisplay) {
              this.compareAtPriceBlockDisplay.textContent = formattedCompareAtPrice;
              this.compareAtPriceBlockDisplay.style.display = 'inline';
            } else if (this.compareAtPriceBlockDisplay) {
              this.compareAtPriceBlockDisplay.style.display = 'none';
            }
        }
      }
      
  
      formatPrice(priceInCents, currency) {
        const priceInDollars = priceInCents / 100;
  
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(priceInCents, window.Shopify.theme.moneyFormat || '${{amount}}');
        }
  
        return new Intl.NumberFormat(navigator.language, {
          style: 'currency',
          currency: currency,
        }).format(priceInDollars);
      }
  
      updateVariantID() {
        if (this.currentVariant) {
          this.variantInput.value = this.currentVariant.id;
          console.log(`Updated Variant ID to: ${this.currentVariant.id}`);
        }
      }
    }
  
    customElements.define('form-selector', FormSelector);
  
    // document.addEventListener('on:variant:change', (event) => {
    //   console.log('Variant changed:', event.detail.variant);
    // });
  });
  